import { render, staticRenderFns } from "./Philosophy.vue?vue&type=template&id=159bbfdb&scoped=true"
import script from "./Philosophy.vue?vue&type=script&lang=js"
export * from "./Philosophy.vue?vue&type=script&lang=js"
import style0 from "./Philosophy.vue?vue&type=style&index=0&id=159bbfdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159bbfdb",
  null
  
)

export default component.exports